import type { CenterProps, LinkProps } from '@hover/blueprint';
import {
  Center,
  Icon,
  Link,
  VStack,
  VisuallyHidden,
  forwardRef,
} from '@hover/blueprint';
import { iAlertCircle, iRefreshCw } from '@hover/icons';
import React, { useState } from 'react';

export interface ImageErrorProps extends CenterProps {
  message?: string;
}

const ImageError = forwardRef<ImageErrorProps, 'div'>(
  ({ children, message, ...props }, ref) => (
    <Center borderRadius="inherit" overflow="hidden" {...props} ref={ref}>
      <VStack position="absolute" spacing="200">
        <Icon
          color="inherit"
          icon={iAlertCircle}
          margin="0 !important"
          size={{ base: 'medium', tablet: 'large' }}
        />
        {children}
      </VStack>
      {message && <VisuallyHidden>{message}</VisuallyHidden>}
    </Center>
  ),
);

const ImageErrorRetry = forwardRef<LinkProps, 'div'>(
  ({ onClick, ...props }, ref) => {
    const [retryRotation, setRetryRotation] = useState(0);

    return (
      <Link
        _hover={{ color: 'neutral.900' }}
        as="button"
        color="inherit"
        cursor="pointer"
        iconAfter={iRefreshCw}
        onClick={event => {
          setRetryRotation(rotation => rotation + 360);
          onClick?.(event);
        }}
        sx={{
          svg: {
            strokeWidth: '2px',
            transition: 'transform 0.75s ease-in-out',
            transform: `rotateZ(${retryRotation}deg)`,
          },
        }}
        textDecoration="underline"
        {...props}
        ref={ref}
      />
    );
  },
);

export { ImageError, ImageErrorRetry };
